module.exports = __webpack_public_path__ + "cc55a988cfe43c47251b565f89c0a4cf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/ghost-s.png
// module id = 1895
// module chunks = 0